var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-logout-1027055") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance-agent-dashboard---1---main-Copy",
    transform: "translate(-31.000000, -515.000000)",
    fill: "#435971",
    fillRule: "nonzero",
    stroke: "#435971",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Default-Menu"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(17.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(15.000000, 422.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-logout-1027055"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.05433833,2.97445959 C9.08529828,3.22610593 9.26731527,3.44458543 9.52798737,3.50953633 C11.1499917,3.91599795 12.5268079,4.89008748 13.456547,6.19323931 C14.3724867,7.47674586 14.8547825,9.08028139 14.7114242,10.7759055 C14.55099,12.6725991 13.6369664,14.3245947 12.2889505,15.4621959 C10.9412341,16.5996159 9.15889734,17.2228323 7.26160258,17.0623792 C5.36490089,16.9019443 3.71290535,15.9879207 2.57530406,14.6399048 C1.43788415,13.2921884 0.814667685,11.5098516 0.975120791,9.61255687 C1.10001482,8.13707416 1.67971756,6.81045374 2.5646795,5.75933968 C3.47510632,4.6779223 4.7083116,3.88655873 5.78432485,2.30260025 C4.13666739,2.73284499 2.67787673,3.66880751 1.60078714,4.94806128 C0.552081966,6.19371774 -0.135120864,7.76351322 -0.28258797,9.50727928 C-0.472373537,11.7502444 0.265557124,13.8585498 1.61206939,15.4539452 C2.95822118,17.0488453 4.91278454,18.1303831 7.15661384,18.3201563 C9.39958154,18.5099421 11.5078869,17.7720114 13.1032823,16.4254992 C14.6981825,15.0793474 15.7797202,13.124784 15.9694935,10.8809547 C16.1389976,8.87701573 15.5678301,6.98047136 14.4836369,5.46115359 C13.3394522,3.85781455 11.623826,2.67550135 9.60453165,2.23161541 L9.05433833,2.97445959 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21297851,0.313365318 L7.77547851,6.41365103 L8.47252149,6.34937754 L7.91002149,0.249091824 L7.21297851,0.313365318 Z",
    id: "Path"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.71a7b65801e4101e7fdaf8ff0c7c2918.svg";
export { ForwardRef as ReactComponent };